import { useState } from "react";
// import { useLocation } from "react-router-dom";
import { AddCircle, MenuDots } from "react-solar-set/essentionalui";
import { navItems } from "../data/navItems";
import Button from "./ui/Button";
import { Tooltip } from "./ui/Tooltip";
import { Link as ScrollLink } from "react-scroll";

const Navbar = () => {
    // const location = useLocation();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [activeSection, setActiveSection] = useState("hero");

    // const scrollToTop = () => {
    //     scroll.scrollToTop();
    // };

    return (
        <nav className="bg-background border-2 p-3 border-stroke text-white flex items-center justify-between rounded-md sticky top-0 z-50 mx-10 my-3 backdrop-blur-sm bg-opacity-95">
            <div className="hidden md:block space-x-2">
                <ul className="list-none flex gap-0.5">
                    {navItems.map((navitem, index) => (
                        <Tooltip
                            key={index}
                            tooltip={navitem.title}
                        >
                            <li>
                                <ScrollLink
                                    className={`flex p-2 rounded-full hover:bg-white/5 transition-colors ease-linear cursor-pointer ${
                                        activeSection === navitem.to
                                            ? "bg-white/10 text-white"
                                            : "text-white/50"
                                    }`}
                                    to={navitem.to}
                                    spy={true}
                                    smooth={true}
                                    offset={-70}
                                    duration={500}
                                    onSetActive={() =>
                                        setActiveSection(navitem.to)
                                    }
                                >
                                    {navitem.icon}
                                </ScrollLink>
                            </li>
                        </Tooltip>
                    ))}
                </ul>
            </div>

            <div className="md:hidden">
                <button
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    className="p-2 rounded-full hover:bg-white/5 transition-colors ease-linear"
                >
                    <MenuDots
                        size={24}
                        iconStyle="LineDuotone"
                        marginHeight={0}
                        color="#ffffff"
                    />
                </button>
                {mobileMenuOpen && (
                    <div className="absolute top-16 left-0 right-0 bg-background border-2 border-stroke rounded-md p-2 z-50 mx-4">
                        <ul className="list-none flex flex-col gap-2">
                            {navItems.map((navitem, index) => (
                                <li key={index}>
                                    <ScrollLink
                                        className={`flex items-center gap-2 p-2 rounded hover:bg-white/5 transition-colors ease-linear cursor-pointer ${
                                            activeSection === navitem.to
                                                ? "bg-white/10 text-white"
                                                : "text-white/50"
                                        }`}
                                        to={navitem.to}
                                        spy={true}
                                        smooth={true}
                                        offset={-70}
                                        duration={500}
                                        onSetActive={() =>
                                            setActiveSection(navitem.to)
                                        }
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        {navitem.icon}
                                        <span>{navitem.title}</span>
                                    </ScrollLink>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>

            <div className="flex items-center space-x-4">
                <Button
                    href="/hire-me"
                    variant="Solid"
                >
                    <AddCircle
                        size={18}
                        iconStyle="LineDuotone"
                        marginHeight={0}
                        color="#ffffff"
                    />
                    <span className="text-sm hidden sm:inline">Hire Me</span>
                </Button>
            </div>
        </nav>
    );
};

export default Navbar;
